import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Grid, MenuItem, Select } from '@material-ui/core';

/**
 * ScoringModule component for rendering a single module or sheet section.
 *
 * Props:
 * - title: string (e.g. 'Preparation Sheet #1')
 * - fields: array of field configs: [{
 *     label: string,
 *     value: any,
 *     onChange: function,
 *     disabled: boolean,
 *     selectId: string,
 *     selectLabelId: string,
 *     options: [{ value, label }],
 *     style: object (optional)
 *   }]
 * - scoreLabel: string (e.g. 'Preparation Sheet #1 Score')
 * - scoreValue: number
 * - classes: object (for styling)
 */
const ScoringModule = ({ title, fields, scoreLabel, scoreValue, classes }) => (
  <>
    <Grid item xs={12} align="left">
      <label style={{ fontWeight: 600 }}>{title}</label>
    </Grid>
    {fields.map((field, idx) => (
      <React.Fragment key={field.selectId || idx}>
        <Grid item xs={12} sm={12} md={5} lg={5} className={classes?.textRowSpacer} align="left" style={field.style || {}}>
          <label id={field.selectLabelId} htmlFor={field.selectId}>
            {field.label}
          </label>
        </Grid>
        <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} className={classes?.textRowSpacer} align="left" style={field.style || {}}>
          <FormControl fullWidth>
            <Select labelId={field.selectLabelId} id={field.selectId} value={field.value} onChange={field.onChange} disabled={field.disabled}>
              {Array.isArray(field.options) &&
                field.options.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
      </React.Fragment>
    ))}
    <Grid item xs={12} sm={12} md={5} lg={5} className={classes?.textRowSpacer} align="left" style={{ marginBottom: 20 }}>
      <label style={{ fontWeight: 600 }}>{scoreLabel}</label>
    </Grid>
    <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
    <Grid item xs={12} sm={12} md={5} lg={5} className={classes?.textRowSpacer} align="left" style={{ marginBottom: 20 }}>
      {scoreValue}
    </Grid>
    <Grid item xs={false} sm={false} md={1} lg={1}></Grid>
  </>
);

ScoringModule.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      onChange: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      selectId: PropTypes.string.isRequired,
      selectLabelId: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.any.isRequired,
          label: PropTypes.string.isRequired,
        })
      ).isRequired,
      style: PropTypes.object,
    })
  ).isRequired,
  scoreLabel: PropTypes.string.isRequired,
  scoreValue: PropTypes.number.isRequired,
  classes: PropTypes.object,
};

export default ScoringModule;
